import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import * as S from './Lesson-styled';

const getButtons = (navItems, onClick, selected) => {
  return navItems.map((navItem, index) => {
    const { icon, title } = navItem;
    const defaultStyle = 'b--light-gray mid-gray';
    const bStyle = index === selected ? 'b--red red' : defaultStyle;

    return (
      <button
        type="button"
        className={`justify-between br2 pa2 h3 f8 source-sans ttc tc mr2 items-center pointer ba bg-white ${bStyle}`}
        key={`lesson-nav-${title}`}
        onClick={() => {
          onClick(index);
        }}
        style={{ width: 72 }}
      >
        <i className={`db icon-${icon} f4 mb2`} aria-hidden />
        {title}
      </button>
    );
  });
};

const LessonNav = ({ navItems, onClick, selected }) => (
  <S.LessonNav data-id="lesson-nav">{getButtons(navItems, onClick, selected)}</S.LessonNav>
);

LessonNav.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      isSelected: PropTypes.bool,
      title: PropTypes.string,
    }),
  ),
  onClick: PropTypes.func,
  selected: PropTypes.number,
};

LessonNav.defaultProps = {
  navItems: [],
  onClick: () => {},
  selected: 0,
};

export default LessonNav;
